import './App.css';
import BackToTopButton from './components/backToButton';
import { Router } from './layouts';

function App() {
  return (
    <div >
    <Router/>
    <BackToTopButton/>
    </div>
  );
}

export default App;
